import { IProduct, IVariant, ProductTagType } from 'base/interfaces/product';
import { IImage } from 'base/interfaces/product';
import { getTargetImage, getVariantImagesList } from 'base/utils/getPicUrl';
import { transImageSrc } from 'base/utils/trans-path';
import { getTagType } from 'base/utils/product'
import { IActivityCode, IActivityCodeOrigin } from 'base/interfacesV2/feature'
import { TAG_PRESALE } from 'mod/product/constant'

type ShopPriceType = number | [number, number];

export type DisplayPricesType = {
    shopPrice: ShopPriceType;
    marketPrice: number;
    savePrice?: number;
    afterDiscountPrice?: number;
};

export const getDisplayPrices = (productVariants: IVariant[]): DisplayPricesType => {
    if (productVariants.length === 0) {
        return {
            shopPrice: 999999,
            marketPrice: 999999,
            savePrice: 0,
        }
    }
    let shopPrice: ShopPriceType = productVariants[0].shopPrice;
    let minItem = productVariants[0];
    let maxItem = productVariants[0];

    if (productVariants.length > 1) {
        for (const item of productVariants) {
            if (item.shopPrice < minItem.shopPrice) {
                minItem = item;
            }
            if (item.shopPrice > maxItem.shopPrice) {
                maxItem = item;
            }
        }
        shopPrice = minItem.shopPrice === maxItem.shopPrice
            ? maxItem.shopPrice
            : [minItem.shopPrice, maxItem.shopPrice];
    }

    return {
        shopPrice: shopPrice,
        marketPrice: maxItem.marketPrice,
        savePrice: maxItem.savePrice,
    };
};

// 获取指定 variant 的图片链接
export const getVariantImageSrc = (images: IImage[], variantId: string, size: number): string => {
    if (images.length === 0) {
        return '';
    }
    let vImages = getVariantImagesList(images, variantId);
    const src = vImages?.length ? vImages[0].picLink : images[0].picLink;
    return transImageSrc(src, size, 2);
}

export const getProductPicLink = (product: IProduct): string => {
    const { images, variantId } = product;
    let { picLink = '' } = product;
    if (typeof images !== 'undefined') {
        const mainImage = getTargetImage(images, variantId, 'isMain');
        picLink = mainImage?.picLink || '';
    }
    return picLink;
}

export const getVariantTagType = (shownVariant?: IVariant): ProductTagType | undefined => {
    const tags = shownVariant?.productTagsVoList || [];
    return getTagType(tags);
}


export const showDeliveryTime = (type?: IActivityCode, product?: IVariant) => {
    return type === TAG_PRESALE && !!product?.deliveryTime
}